import { useCallback } from "react"
import { DashBoardCondition } from "features/dashBoard/types"
import { useTreeMapGraphOption } from "./options"

type useTreeMapGraphEventsProps<T> = {
	graphOption: ReturnType<typeof useTreeMapGraphOption<T>>
	onChangeCondition: (
    axisKey?: string,
    changed?: DashBoardCondition,
    toggle?: boolean
  ) => void
}
export const useTreeMapGraphEvents = <T,>({
	graphOption: {
		axisDef
	},
	onChangeCondition
}: useTreeMapGraphEventsProps<T>) => {
  const onClickAera = useCallback(
    (params?: {
      data?: {
        code: string,
        name: string
      },
      event?: {
        event?: {
          ctrlKey: boolean
        }
      }
    }) => {
      if (!axisDef?.key) return
      const data = params?.data
      if (!data) return
      onChangeCondition(
        axisDef.key,
        { code: [data.code], label: data.name },
        params?.event?.event?.ctrlKey ? true : false
      )
    },
    [axisDef, onChangeCondition]
  )
	return {
		click: onClickAera
	}
}